/* eslint-disable react/prop-types */
import React, { createContext, useState, useContext } from "react";

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [nestedDropdownId, setNestedDropdownId] = useState(null);

  const openDropdown = (id) => {
    setActiveDropdownId(id);

    setNestedDropdownId(null);
  };

  const closeDropdown = () => {
    setActiveDropdownId(null);
    setNestedDropdownId(null);
  };

  const toggleDropdown = (id) => {
    if (activeDropdownId === id) {
      closeDropdown();
    } else {
      openDropdown(id);
    }
  };

  const openNestedDropdown = (id) => {
    setNestedDropdownId(id);
  };

  const closeNestedDropdown = () => {
    setNestedDropdownId(null);
  };

  const toggleNestedDropdown = (id) => {
    if (nestedDropdownId === id) {
      closeNestedDropdown();
    } else {
      openNestedDropdown(id);
    }
  };

  return (
    <FilterContext.Provider
      value={{
        activeDropdownId,
        openDropdown,
        closeDropdown,
        toggleDropdown,
        nestedDropdownId,
        openNestedDropdown,
        closeNestedDropdown,
        toggleNestedDropdown,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useDropdown = () => useContext(FilterContext);

export default FilterProvider;
